// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m8-1";
export var messageSideRight = "_m8-2";
export var orderLookupBubbleContainer = "_m8-0";
export var submitButton = "_m8-3";